import { useState } from "react";
import { FiArrowRight, FiAward, FiLoader, FiX } from "react-icons/fi";
import { clickAffiliateOffer } from "./affiliateApi";

type Props = {
  offer: any;
  userId: number;
  onClose: () => void;
  ipAddress: string;
};

const AffiliateOfferModal = ({ offer, userId, onClose, ipAddress }: Props) => {
  const [loading, setLoading] = useState(false);

  const handleContinue = async () => {
    try {
      setLoading(true);

      // call backend (IMPORTANT)
      const res = await clickAffiliateOffer(offer.id, userId, ipAddress);

      const finalUrl = res?.url;

      if (finalUrl) {
        window.open(finalUrl, "_blank");
      }
    } catch (err) {
      console.error("Click error:", err);
    } finally {
      setLoading(false);
      onClose();
    }
  };

  return (
    <div className="zs-backdrop" role="dialog" aria-modal="true" aria-labelledby="affiliate-offer-title">
      <div className="zs-modal">
        {/* Close */}
        <button onClick={onClose} className="zs-icon-btn zs-modal-close z-[1] bg-surface/90" aria-label="Close">
          <FiX />
        </button>

        {/* Banner */}
        <div className="bg-surface-2">
          <img src={offer.banner_url} alt="" className="w-full h-[170px] object-cover" />
        </div>

        <div className="p-5">
          {/* Title */}
          <h2 id="affiliate-offer-title" className="text-lg font-semibold leading-snug font-display text-ink">
            {offer.title}
          </h2>
          <p className="mt-1 text-sm leading-relaxed text-ink-3">{offer.description}</p>

          {/* Steps */}
          <div className="mt-4">
            {offer.steps && offer.steps.length > 0 && (
              <div className="p-4 border rounded-lg border-line bg-surface-2">
                <h4 className="mb-3 text-xs font-semibold tracking-wide uppercase text-ink-3">Steps to Complete</h4>
                <ol className="flex flex-col gap-2.5 text-sm">
                  {offer.steps?.map((step: string, index: number) => (
                    <li key={index} className="flex gap-3">
                      <span className="inline-flex items-center justify-center w-5 h-5 text-[11px] font-semibold rounded-full shrink-0 bg-primary-soft text-primary-text tabular-nums">
                        {index + 1}
                      </span>
                      <span className="text-ink-2">{step}</span>
                    </li>
                  ))}
                </ol>
              </div>
            )}
          </div>

          {/* Reward */}
          <div className="flex items-center justify-center gap-2 mt-4 text-sm font-medium text-success">
            <FiAward />
            Earn reward after completion
          </div>

          {/* Button */}
          <button onClick={handleContinue} disabled={loading} className="mt-4 zs-btn zs-btn-primary zs-btn-lg zs-btn-block">
            {loading ? (
              <>
                <FiLoader className="animate-spin" />
                Redirecting...
              </>
            ) : (
              <>
                Continue & Earn
                <FiArrowRight />
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AffiliateOfferModal;
